import { inject } from 'vue';
import ApiService from '@/services/api.service.js';

export default function usePriceRepository(pricePeriodId) {
  const appsettings = inject('appsettings');
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productprices/overview${params}`);
  };

  const update = (key, values) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productprices/${key}`, { values: JSON.stringify(values) });

  const insert = (values) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productprices`, { values: JSON.stringify(values) });

  const remove = (key) => ApiService
    .delete(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productprices/${key}`);

  const importPriceList = (formData) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${pricePeriodId}/productprices/import`, formData);

  return {
    load,
    update,
    insert,
    remove,
    importPriceList,
  };
}
